<template>
  <div class="pos-container p-3">
    <div class="container-fluid">
      <!-- Tahrirlash rejimi banneri -->
      <div v-if="editId" class="edit-banner d-flex justify-content-between align-items-center mb-3">
        <span>✏️ <b>Savdo #{{ editId }}</b> tahrirlanmoqda — saqlasangiz eski savdo qayta hisoblanadi</span>
        <button class="btn btn-sm btn-light" @click="cancelEdit">Bekor qilish</button>
      </div>
      <div class="row g-3">

        <!-- CHAP TOMON: Header + Savatlar paneli + Mahsulotlar -->
        <div class="col-lg-8">
          <SaleHeaderBar
            :form.sync="form"
            :clientList="clientList"
            :ustaList="ustaList"
            :bronList="bronList"
            :clientCars="clientCars"
            :saleType="saleType"
            @client-changed="onClientChange"
            @master-changed="onMasterChange"
            @bron-selected="onBronSelect"
            @car-selected="onCarSelected"
            @client-added="onClientAdded"
            @car-added="onCarAdded"
            @sale-type-changed="onSaleTypeChanged"
            @toggle-baskets="showBaskets = !showBaskets"
            @new-basket="newBasket"
          />

          <!-- Savatlar paneli (Ojdaniya) -->
          <div v-if="showBaskets" class="baskets-panel mb-3">
            <div class="card border-0 shadow-sm rounded-4 overflow-hidden">
              <div class="card-header bg-warning bg-opacity-10 d-flex justify-content-between align-items-center py-2 px-3">
                <span class="fw-bold small text-dark">&#128722; Savatlar ({{ bronList.length }})</span>
                <button class="btn btn-sm btn-outline-dark border-0 py-0" @click="showBaskets = false">&times;</button>
              </div>
              <div class="card-body p-2" style="max-height: 220px; overflow-y: auto;">
                <div v-if="bronList.length === 0" class="text-center py-3">
                  <p class="text-muted small mb-0">Saqlangan savatlar yo'q</p>
                </div>
                <div
                  v-for="bron in bronList"
                  :key="bron.id"
                  class="basket-item d-flex justify-content-between align-items-center px-3 py-2 mb-1 rounded-3"
                  :class="{ 'basket-active': form.bron_id === bron.id }"
                >
                  <div class="flex-grow-1 cursor-pointer" @click="onBronSelect(bron.id)">
                    <div class="fw-bold small">#{{ bron.id }} {{ bron.kontragent ? bron.kontragent.name : 'Nomsiz' }}</div>
                    <div class="text-muted" style="font-size: 0.7rem;">
                      {{ bron.products ? bron.products.length : 0 }} mahsulot
                      <span v-if="bron.services && bron.services.length"> + {{ bron.services.length }} xizmat</span>
                      <span v-if="bron.summa"> &middot; {{ Number(bron.summa).toLocaleString() }} so'm</span>
                    </div>
                  </div>
                  <div class="d-flex gap-1">
                    <button class="btn btn-sm btn-outline-primary border-0 py-0 px-1" @click="onBronSelect(bron.id)" title="Yuklash">&#9998;</button>
                    <button class="btn btn-sm btn-outline-danger border-0 py-0 px-1" @click="deleteBasket(bron.id)" title="O'chirish">&times;</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ProductBrowser
            :saleType="saleType"
            :cart="cart"
            @select-package="selectPackage"
            @add-product="addProductToCart"
            @decrease-package="decreasePackageById"
            @decrease-product="decreaseProductById"
          />
        </div>

        <!-- O'NG TOMON: Savatcha va To'lov -->
        <div class="col-lg-4">
          <SaleCartSidebar
            :cart="cart"
            :form.sync="form"
            :saleType="saleType"
            :totalSum="totalSum"
            :productSumma="productSumma"
            :serviceSumma="serviceSumma"
            :paidTotal="paidTotal"
            :masterPercent="masterPercent"
            :masterSumma="masterSumma"
            :loading="loading"
            :clientDebt="clientDebt"
            @remove-item="removeFromCart"
            @increase-qty="increaseQty"
            @decrease-qty="decreaseQty"
            @update-price="onUpdatePrice"
            @toggle-price-lock="onTogglePriceLock"
            @update-discount-percent="onUpdateDiscountPercent"
            @clear-all="clearAll"
            @clear-services="clearServices"
            @pay-debt="payClientDebt"
            @submit="submitSale"
          />
        </div>

      </div>
    </div>

    <!-- Chek modali -->
    <SaleReceiptModal
      :show="receipt.show"
      :firmName="receipt.firmName"
      :phone="receipt.phone"
      :checkWord="receipt.checkWord"
      :logoUrl="receipt.logoUrl"
      :clientName="receipt.clientName"
      :masterName="receipt.masterName"
      :carNumber="receipt.carNumber"
      :cart="receipt.cart"
      :totalSum="receipt.totalSum"
      :skidka="receipt.skidka"
      :paidSumma="receipt.paidSumma"
      :previousDebt="receipt.previousDebt"
      :priceType="receipt.priceType"
      :debtDueDate="receipt.debtDueDate"
      :debtComment="receipt.debtComment"
      :saleId="receipt.saleId"
      :saleCreatedAt="receipt.saleCreatedAt"
      :payments="receipt.payments"
      @close="closeReceipt"
    />
  </div>
</template>

<script>
import axios from 'axios';
import SaleHeaderBar from './components/SaleHeaderBar.vue';
import ProductBrowser from './components/ProductBrowser.vue';
import SaleCartSidebar from './components/SaleCartSidebar.vue';
import SaleReceiptModal from './components/SaleReceiptModal.vue';

export default {
  name: 'ChiqimPos',
  components: { SaleHeaderBar, ProductBrowser, SaleCartSidebar, SaleReceiptModal },

  data() {
    return {
      loading: false,
      saving: false,
      showBaskets: false,
      _skipAutoSave: false,
      editId: null,      // tahrirlash rejimida — mavjud savdo id'si
      clientList: [],
      ustaList: [],
      bronList: [],
      clientCars: [],
      payTypesAll: [],   // chek per-pay_type breakdown uchun
      cart: [],          // unified: { type:'product'|'service', id, name, price?, labor_price?, redo_price?, qty }
      saleType: 'chakana', // 'chakana' yoki 'optom'
      masterPercent: 0,
      clientDebt: 0,

      // Sklad sozlamalari (chek uchun)
      skladSettings: {
        firmName: '',
        phone: '',
        checkWord: '',
        logoUrl: '',
      },

      // Chek modal ma'lumotlari
      receipt: {
        show: false,
        firmName: '',
        phone: '',
        checkWord: '',
        logoUrl: '',
        clientName: "NOMA'LUM",
        masterName: '',
        carNumber: '',
        cart: [],
        totalSum: 0,
        skidka: 0,
        paidSumma: 0,
        previousDebt: 0,
        saleId: 0,
        saleCreatedAt: 0,
      },

      form: {
        kontragent_id: null,
        master_user_id: null,
        bron_id: null,
        car_number: '',
        comment: '',
        skidka_summa: 0,
        paid_summa: 0,
        pay_type_id: 1,
        debt_due_date: null,
        debt_comment: '',
      },
    };
  },

  computed: {
    productSumma() {
      return this.cart
        .filter(i => i.type === 'product')
        .reduce((sum, i) => sum + Number(i.price) * Number(i.qty), 0);
    },
    // 1. original_summa — barcha mahsulotlar asl narxi + xizmatlar
    //    Agar erkin narx asl narxdan QIMMAT bo'lsa, original = price (qimmat sotishni hisobga oladi)
    originalProductSumma() {
      return this.cart
        .filter(i => i.type === 'product')
        .reduce((sum, i) => {
          const sold = Number(i.price) || 0;
          const orig = Math.max(Number(i.original_price || 0) || sold, sold);
          return sum + orig * Number(i.qty);
        }, 0);
    },
    originalSumma() {
      return this.originalProductSumma + this.serviceSumma;
    },
    // 2. arzon_summa — faqat ARZON sotilganda: Σ((original_price − price) × qty)
    //    Qimmat sotilganda 0 (Math.max bilan).
    arzonSumma() {
      return this.cart
        .filter(i => i.type === 'product')
        .reduce((sum, i) => {
          const sold = Number(i.price) || 0;
          const orig = Number(i.original_price || 0) || sold;
          const diff = Math.max(0, orig - sold);
          return sum + diff * Number(i.qty);
        }, 0);
    },
    // 4. discount_summa — qo'shimcha chegirma (skidka_summa bilan bir xil)
    discountSumma() {
      return Number(this.form.skidka_summa || 0);
    },
    // 3. paid_summa — hozir to'lanayotgan summa
    paidSumma() {
      return Number(this.form.paid_summa || 0);
    },
    // 5. qarz_summa — qarz: summa − paid_summa
    qarzSumma() {
      return Math.max(0, this.totalSum - this.paidSumma);
    },
    serviceSumma() {
      return this.cart
        .filter(i => i.type === 'service')
        .reduce((sum, i) => {
          let price = 0;
          if (this.saleType === 'optom') {
            price = Number(i.labor_price_optom || 0) + Number(i.redo_price_optom || 0);
          } else {
            price = Number(i.labor_price_chakana || 0) + Number(i.redo_price_chakana || 0);
          }
          return sum + price * Number(i.qty);
        }, 0);
    },
    totalSum() {
      return this.productSumma + this.serviceSumma - Number(this.form.skidka_summa || 0);
    },
    paidTotal() {
      return Number(this.form.paid_summa || 0);
    },
    masterSumma() {
      // Usta bonusi faqat savdo (mahsulot) summasidan. Xizmatlar bonusdan chetda.
      return (this.productSumma * this.masterPercent) / 100;
    },
  },

  watch: {
    cart: {
      handler() { this.scheduleAutoSave(); },
      deep: true,
    },
    'form.kontragent_id'() { this.scheduleAutoSave(); },
    'form.master_user_id'() { this.scheduleAutoSave(); },
    'form.comment'() { this.scheduleAutoSave(); },
    'form.skidka_summa'() { this.scheduleAutoSave(); },
  },

  mounted() {
    this.initData();
  },

  beforeDestroy() {
    clearTimeout(this._autoSaveTimer);
  },

  methods: {
    async initData() {
      await Promise.all([
        this.fetchClients(),
        this.fetchUstas(),
        this.fetchBrons(),
        this.fetchSkladSettings(),
        this.fetchPayTypesAll(),
      ]);

      // Tahrirlash rejimi — ?edit=<savdo id>
      const editId = this.$route.query.edit;
      if (editId) {
        await this.loadSaleForEdit(Number(editId));
        return;
      }

      const selectedBronId = localStorage.getItem('selected_bron_id');
      if (selectedBronId) {
        localStorage.removeItem('selected_bron_id');
        this.onBronSelect(Number(selectedBronId));
        return;
      }

      // POS'ga kirganda eski qolib ketgan savatlar bo'lsa — ro'yxatni avtomatik ochish
      if (this.bronList.length > 0 && this.cart.length === 0) {
        this.showBaskets = true;
      }
    },

    scheduleAutoSave() {
      if (this._skipAutoSave) return;
      clearTimeout(this._autoSaveTimer);
      this._autoSaveTimer = setTimeout(() => {
        this.autoSaveBasket();
      }, 600);
    },

    async fetchClients() {
      try {
        const res = await axios.get('api/v1/kontragent/type/1');
        this.clientList = res.data;
      } catch (e) { console.error("Mijozlarni yuklashda xato", e); }
    },
    async fetchUstas() {
      try {
        const res = await axios.get('api/v1/staff');
        this.ustaList = res.data?.data || [];
      } catch (e) { console.error("Ustalarni yuklashda xato", e); }
    },
    async fetchBrons() {
      try {
        const res = await axios.get('api/v1/service-sale/brons');
        this.bronList = res.data?.data || [];
      } catch (e) { this.bronList = []; }
    },
    async fetchClientDebt(clientId) {
      if (!clientId) { this.clientDebt = 0; return; }
      try {
        const res = await axios.post('api/v1/kontragent/total', { kontragent_id: clientId });
        const data = res.data || [];
        const total = data.reduce((sum, item) => sum + Number(item.total || 0), 0);
        this.clientDebt = Math.abs(total);
      } catch (e) { this.clientDebt = 0; }
    },

    async fetchSkladSettings() {
      const sklad_id = localStorage.getItem('sklad_id');
      if (!sklad_id) return;
      try {
        // Sklad asosiy ma'lumotlari (nomi, telefon, chek izohi)
        const [skladRes, settingsRes] = await Promise.all([
          axios.get(`api/v1/sklads/id/${sklad_id}`),
          axios.post('api/v1/sklad-settings', { sklad_id, key: 'a4_printer' }),
        ]);

        const sklad = skladRes.data?.data || skladRes.data || {};
        this.skladSettings.phone     = sklad.phone_number || '';
        this.skladSettings.checkWord = sklad.check_word   || '';

        // Firma nomini printer sozlamalaridan olish (yo'q bo'lsa sklad nomidan)
        const printerData = settingsRes.data?.data;
        if (printerData) {
          const parsed = JSON.parse(printerData);
          this.skladSettings.firmName = parsed?.sender?.firm_name || sklad.name || '';
          if (parsed?.file_name) {
            this.skladSettings.logoUrl = axios.defaults.baseURL + 'api/v1/uploads/' + parsed.file_name;
          }
        } else {
          this.skladSettings.firmName = sklad.name || '';
        }
      } catch (e) {
        console.error("Sklad sozlamalarini yuklashda xato", e);
      }
    },

    onClientChange(id) {
      this.fetchClientDebt(id);
      this.fetchClientCars(id);
      // Mijozning sale_type ga qarab optom/chakana tanlash
      const client = this.clientList.find(c => c.id === id);
      if (client && client.sale_type) {
        this.saleType = client.sale_type;
      } else {
        this.saleType = 'chakana';
      }
    },
    async fetchClientCars(clientId) {
      if (!clientId) { this.clientCars = []; return; }
      try {
        const res = await axios.get(`api/v1/client-profile/cars`, { params: { kontragent_id: clientId } });
        this.clientCars = res.data?.data || res.data || [];
      } catch (e) { this.clientCars = []; }
    },
    onCarSelected(car) {
      if (!car) {
        this.form.car_number = '';
        return;
      }
      this.form.car_number = car.car_number || '';
    },
    async onClientAdded(client) {
      await this.fetchClients();
      if (client?.id) {
        this.form.kontragent_id = client.id;
        this.onClientChange(client.id);
      }
    },
    async onBronSelect(id) {
      const bron = this.bronList.find(b => b.id === id);
      if (!bron) return;
      // Agar boshqa savatdan o'tayotgan bo'lsak — joriy savat kutilayotgan o'zgarishlarini saqlab olish
      if (this.form.bron_id && this.form.bron_id !== id) {
        await this.flushAutoSave();
      }

      // Auto-save ni to'xtatish (bron yuklayotganda)
      this._skipAutoSave = true;
      clearTimeout(this._autoSaveTimer);

      // Avval savatni tozalash
      this.cart = [];
      this.form.kontragent_id = bron.kontragent_id;
      this.form.bron_id = bron.id;
      this.form.comment = bron.comment || '';
      this.form.skidka_summa = Number(bron.skidka_summa || 0);
      this.form.master_user_id = null;
      this.form.car_number = '';

      // Mijozning sale_type ni o'rnatish
      const client = this.clientList.find(c => c.id === bron.kontragent_id);
      if (client && client.sale_type) {
        this.saleType = client.sale_type;
      }
      if (bron.kontragent_id) {
        this.fetchClientDebt(bron.kontragent_id);
        this.fetchClientCars(bron.kontragent_id);
      } else {
        this.clientDebt = 0;
        this.clientCars = [];
      }

      // Xizmatlarni yuklash
      if (bron.services?.length > 0) {
        for (const srv of bron.services) {
          this.cart.push({
            id: srv.package_id,
            name: srv.name || 'Xizmat',
            labor_price_chakana: Number(srv.labor_price_chakana || 0),
            redo_price_chakana: Number(srv.redo_price_chakana || 0),
            labor_price_optom: Number(srv.labor_price_optom || 0),
            redo_price_optom: Number(srv.redo_price_optom || 0),
            qty: 1,
            type: 'service',
          });
        }
      }

      // Mahsulotlarni yuklash — original_price saqlanadi.
      // Erkin narx (arzon yoki qimmat) bo'lsa switch ochiq holatda tiklanadi.
      if (bron.products?.length > 0) {
        for (const p of bron.products) {
          const price = Number(p.price);
          const original = Number(p.original_price || 0) || price;
          const isFreePrice = original !== price;
          this.cart.push({
            id: p.product_id,
            name: p.product?.name || p.product?.extra_name || 'Mahsulot',
            price,
            original_price: original,
            price_unlocked: isFreePrice,
            qty: Number(p.count),
            balance: 0,
            type: 'product',
          });
        }
      }

      // Auto-save ni qayta yoqish (panel ochiq qoladi — boshqa savatga osonlik bilan o'tish uchun)
      this.$nextTick(() => { this._skipAutoSave = false; });
    },

    async flushAutoSave() {
      // 1. Mid-flight avtosaqlashni kutib turamiz (konkurent POST tugashini)
      const start = Date.now();
      while (this.saving && Date.now() - start < 10000) {
        await new Promise(r => setTimeout(r, 50));
      }
      // 2. Kutayotgan debounce timer bo'lsa — darhol ishga tushirib, tugashini kutamiz
      if (this._autoSaveTimer) {
        clearTimeout(this._autoSaveTimer);
        this._autoSaveTimer = null;
        if (!this._skipAutoSave) {
          try { await this.autoSaveBasket(); } catch (e) { /* ignore */ }
        }
      }
    },

    async newBasket() {
      // Joriy savatning kutilayotgan o'zgarishlarini saqlab olamiz
      await this.flushAutoSave();
      // Toza savat: form va cart reset, bron_id=null — keyingi qo'shimcha avtosave yangi bron yaratadi
      this._skipAutoSave = true;
      clearTimeout(this._autoSaveTimer);
      this.cart = [];
      this.form = {
        kontragent_id: null,
        master_user_id: null,
        bron_id: null,
        car_number: '',
        comment: '',
        skidka_summa: 0,
        paid_summa: 0,
        pay_type_id: 1,
        debt_due_date: null,
        debt_comment: '',
      };
      this.masterPercent = 0;
      this.clientDebt = 0;
      this.clientCars = [];
      this.saleType = 'chakana';
      await this.fetchBrons();
      this.$nextTick(() => { this._skipAutoSave = false; });
    },

    async autoSaveBasket() {
      if (this.cart.length === 0) {
        // Savat bo'sh — mavjud bronni o'chirish
        if (this.form.bron_id) {
          try {
            await axios.delete(`api/v1/bron/id/${this.form.bron_id}`);
            this.form.bron_id = null;
            this.fetchBrons();
          } catch (e) { /* ignore */ }
        }
        return;
      }
      if (this.saving) return;
      this.saving = true;

      try {
        const sklad_id = Number(localStorage.getItem('sklad_id')) || 1;

        const products = this.cart
          .filter(i => i.type === 'product')
          .map(i => ({
            product_id: i.id,
            count: i.qty,
            price: i.price,
            original_price: Number(i.original_price || i.price || 0),
          }));

        const services = this.cart
          .filter(i => i.type === 'service')
          .map(i => ({
            package_id: i.id,
            name: i.name,
            labor_price_chakana: i.labor_price_chakana,
            redo_price_chakana: i.redo_price_chakana,
            labor_price_optom: i.labor_price_optom,
            redo_price_optom: i.redo_price_optom,
            product_summa: 0,
            price: this.saleType === 'optom'
              ? Number(i.labor_price_optom || 0) + Number(i.redo_price_optom || 0)
              : Number(i.labor_price_chakana || 0) + Number(i.redo_price_chakana || 0),
          }));

        // Agar mavjud bron bo'lsa — o'chirib qaytadan yaratish
        if (this.form.bron_id) {
          try { await axios.delete(`api/v1/bron/id/${this.form.bron_id}`); } catch (e) { /* ignore */ }
        }

        const payload = {
          kontragent_id: this.form.kontragent_id,
          sklad_id,
          comment: this.form.comment || 'Savat',
          skidka_summa: Number(this.form.skidka_summa || 0),
          products,
          services,
        };

        const res = await axios.post('api/v1/bron/makeOrder', payload);
        this.form.bron_id = res.data?.data?.id;
        this.fetchBrons();
      } catch (e) {
        console.error('Auto-save xato:', e);
      } finally {
        this.saving = false;
      }
    },

    async deleteBasket(id) {
      if (!confirm("Bu savatni o'chirmoqchimisiz?")) return;
      try {
        await axios.delete(`api/v1/bron/id/${id}`);
        if (this.form.bron_id === id) {
          this.form.bron_id = null;
          this.cart = [];
        }
        await this.fetchBrons();
      } catch (e) {
        alert("O'chirishda xato!");
      }
    },
    async onCarAdded(car) {
      if (this.form.kontragent_id) {
        await this.fetchClientCars(this.form.kontragent_id);
        if (car?.car_number) {
          this.form.car_number = car.car_number;
        }
      }
    },
    onMasterChange(id) {
      if (!id) { this.masterPercent = 0; return; }
      const usta = this.ustaList.find(u => u.id === id);
      this.masterPercent = usta ? (usta.percent || usta.bonus || 0) : 0;
    },
    selectPackage(pkg) {
      const exist = this.cart.find(c => c.type === 'service' && c.id === pkg.id);
      if (exist) {
        exist.qty++;
        // Xizmatga tegishli mahsulotlar sonini ham oshirish
        this.cart.forEach(c => {
          if (c.type === 'product' && c.from_service === pkg.id) {
            c.qty += c.base_qty;
          }
        });
      } else {
        this.cart.push({
          id: pkg.id,
          name: pkg.name,
          labor_price_chakana: Number(pkg.labor_price_chakana || 0),
          redo_price_chakana: Number(pkg.redo_price_chakana || 0),
          labor_price_optom: Number(pkg.labor_price_optom || 0),
          redo_price_optom: Number(pkg.redo_price_optom || 0),
          qty: 1,
          type: 'service',
        });
        // Xizmatga tegishli mahsulotlarni savatga qo'shish
        if (pkg.items && pkg.items.length > 0) {
          for (const item of pkg.items) {
            const itemPrice = this.saleType === 'optom'
              ? Number(item.price_optom || 0)
              : Number(item.price_chakana || 0);
            this.cart.push({
              id: item.product_id,
              name: (item.product?.name || item.product?.extra_name || 'Mahsulot'),
              price: itemPrice,
              price_chakana: Number(item.price_chakana || 0),
              price_optom: Number(item.price_optom || 0),
              qty: Number(item.quantity || 1),
              base_qty: Number(item.quantity || 1),
              balance: 0,
              type: 'product',
              from_service: pkg.id,
            });
          }
        }
      }
    },

    addProductToCart(product) {
      const pr = product.price_register;
      const chakana = pr ? Number(pr.chakana_price || 0) : 0;
      const optom   = pr ? Number(pr.optom_price   || 0) : 0;
      const price = this.saleType === 'optom' ? optom : chakana;
      const exist = this.cart.find(c => c.type === 'product' && c.id === product.id && !c.from_service);
      if (exist) {
        exist.qty++;
      } else {
        this.cart.push({
          id: product.id,
          name: product.name || product.extra_name,
          price: price,
          original_price: price,
          price_chakana: chakana,
          price_optom: optom,
          qty: 1,
          balance: product.balance || 0,
          type: 'product',
        });
      }
    },
    onUpdatePrice({ item, price }) {
      const target = this.cart.find(c => c === item);
      if (!target) return;
      // original_price bor bolmasa (eski cart), hozirgi narxni asl deb saqlab qoyamiz
      if (target.original_price === undefined || target.original_price === null) {
        target.original_price = target.price;
      }
      target.price = Number(price) || 0;
    },
    onTogglePriceLock({ item, unlocked }) {
      const target = this.cart.find(c => c === item);
      if (!target) return;
      this.$set(target, 'price_unlocked', unlocked);
      // Switch yopilsa — narxni asl narxga qaytaramiz va chegirma foizini ham
      if (!unlocked && target.original_price !== undefined && target.original_price !== null) {
        target.price = Number(target.original_price) || 0;
        this.$set(target, 'discount_percent', 0);
      }
    },
    onUpdateDiscountPercent({ item, percent }) {
      const target = this.cart.find(c => c === item);
      if (!target) return;
      // original_price bo'lmasa, hozirgi narxni asl deb belgilaymiz
      if (target.original_price === undefined || target.original_price === null || target.original_price <= 0) {
        target.original_price = target.price;
      }
      const pct = Math.max(0, Math.min(100, Number(percent) || 0));
      this.$set(target, 'discount_percent', pct);
      // Narxni asl narxdan chegirma foizi bilan hisoblab qo'yamiz
      const orig = Number(target.original_price) || 0;
      const newPrice = +(orig * (1 - pct / 100)).toFixed(2);
      target.price = newPrice;
      // Erkin narx switchini avto-yoqish — foydalanuvchi keyinroq qo'lda ham o'zgartirsa bo'ladi
      if (!target.price_unlocked) this.$set(target, 'price_unlocked', true);
    },
    async onSaleTypeChanged(type) {
      this.saleType = type;
      // Savatchadagi mahsulot narxlarini yangilash
      const sklad_id = localStorage.getItem('sklad_id');
      for (const item of this.cart) {
        if (item.type === 'product' && item.from_service) {
          // Xizmatga tegishli mahsulotlar — o'z narxlari bor
          item.price = type === 'optom' ? Number(item.price_optom || 0) : Number(item.price_chakana || 0);
        } else if (item.type === 'product') {
          try {
            const res = await axios.post('api/v1/product/price-balance', {
              product_id: item.id,
              sklad_id: Number(sklad_id),
            });
            const pr = res.data;
            item.price = type === 'optom' ? Number(pr.optom_price || 0) : Number(pr.chakana_price || 0);
          } catch (e) {
            console.error("Narxni yangilashda xato", e);
          }
        }
        // Xizmatlar uchun narx alohida saqlanadi, serviceSumma computed orqali hisoblanadi
      }
    },

    increaseQty(item) {
      item.qty++;
      // Xizmat qty oshganda tegishli mahsulotlar ham oshishi kerak
      if (item.type === 'service') {
        this.cart.forEach(c => {
          if (c.type === 'product' && c.from_service === item.id) {
            c.qty += c.base_qty;
          }
        });
      }
    },
    decreaseQty(item) {
      if (item.qty > 1) {
        item.qty--;
        // Xizmat qty kamaytirilganda tegishli mahsulotlar ham kamayishi kerak
        if (item.type === 'service') {
          this.cart.forEach(c => {
            if (c.type === 'product' && c.from_service === item.id) {
              c.qty -= c.base_qty;
              if (c.qty < c.base_qty) c.qty = c.base_qty;
            }
          });
        }
      }
    },
    decreasePackageById(pkgId) {
      const idx = this.cart.findIndex(c => c.type === 'service' && c.id === pkgId);
      if (idx === -1) return;
      const item = this.cart[idx];
      if (item.qty > 1) {
        item.qty--;
        this.cart.forEach(c => {
          if (c.type === 'product' && c.from_service === pkgId) {
            c.qty -= c.base_qty;
            if (c.qty < c.base_qty) c.qty = c.base_qty;
          }
        });
      } else {
        this.cart = this.cart.filter(c => c !== item && c.from_service !== pkgId);
      }
    },
    decreaseProductById(productId) {
      const idx = this.cart.findIndex(c => c.type === 'product' && c.id === productId && !c.from_service);
      if (idx === -1) return;
      const item = this.cart[idx];
      if (item.qty > 1) {
        item.qty--;
      } else {
        this.cart.splice(idx, 1);
      }
    },
    removeFromCart(idx) {
      const item = this.cart[idx];
      if (item && item.type === 'service') {
        // Xizmatga tegishli mahsulotlarni ham o'chirish
        this.cart = this.cart.filter((c, i) => i !== idx && c.from_service !== item.id);
      } else {
        this.cart.splice(idx, 1);
      }
    },

    clearServices() {
      this.cart = this.cart.filter(i => i.type !== 'service' && !i.from_service);
    },
    async clearAll() {
      // Avval bronni o'chirish
      if (this.form.bron_id) {
        try { await axios.delete(`api/v1/bron/id/${this.form.bron_id}`); } catch (e) { /* ignore */ }
        this.fetchBrons();
      }
      this._skipAutoSave = true;
      this.cart = [];
      this.form = {
        ...this.form,
        bron_id: null,
        skidka_summa: 0,
        paid_summa: 0,
        pay_type_id: 1,
        debt_due_date: null,
        debt_comment: '',
      };
      this.$nextTick(() => { this._skipAutoSave = false; });
    },

    async payClientDebt(payment) {
      if (!this.form.kontragent_id) return alert("Mijoz tanlanmagan!");
      try {
        await axios.post('api/v1/payment/debt', {
          kontragent_id: this.form.kontragent_id,
          ...payment
        });
        alert("To'lov qabul qilindi");
        this.fetchClientDebt(this.form.kontragent_id);
      } catch (e) { alert("Xatolik!"); }
    },

    showReceipt(savedSale) {
      const client = this.clientList.find(c => c.id === this.form.kontragent_id);
      const usta   = this.ustaList.find(u => u.id === this.form.master_user_id);

      this.receipt = {
        show:         true,
        firmName:     this.skladSettings.firmName,
        phone:        this.skladSettings.phone,
        checkWord:    this.skladSettings.checkWord,
        logoUrl:      this.skladSettings.logoUrl,
        clientName:   client ? client.name : "NOMA'LUM",
        masterName:   usta ? usta.name : '',
        carNumber:    this.form.car_number || '',
        cart:         JSON.parse(JSON.stringify(this.cart)).map(item => {
          if (item.type === 'service') {
            // Chekda faqat tanlangan narx turini ko'rsatish
            if (this.saleType === 'optom') {
              item.labor_price = Number(item.labor_price_optom || 0);
              item.redo_price = Number(item.redo_price_optom || 0);
            } else {
              item.labor_price = Number(item.labor_price_chakana || 0);
              item.redo_price = Number(item.redo_price_chakana || 0);
            }
          }
          return item;
        }),
        totalSum:     this.totalSum,
        skidka:       Number(this.form.skidka_summa || 0),
        paidSumma:    Number(this.form.paid_summa || 0),
        previousDebt: Number(this.clientDebt || 0),
        priceType:    this.saleType,
        debtDueDate:  this.qarzSumma > 0 ? Number(this.form.debt_due_date || 0) : 0,
        debtComment:  this.qarzSumma > 0 ? (this.form.debt_comment || '') : '',
        saleId:        Number(savedSale && savedSale.id || 0),
        saleCreatedAt: Number(savedSale && savedSale.created_at || 0),
        // Per-pay_type breakdown chek uchun (har to'lov turi alohida ko'rinadi)
        payments:     this._buildReceiptPayments(),
      };
    },

    async fetchPayTypesAll() {
      try {
        const res = await axios.get('api/v1/pay-type/');
        this.payTypesAll = Array.isArray(res.data) ? res.data : [];
      } catch (e) { this.payTypesAll = []; }
    },

    // form.payments[] dan pay_type nomlarini olib chek formatiga o'giramiz
    _buildReceiptPayments() {
      const arr = Array.isArray(this.form.payments) ? this.form.payments : [];
      const pts = Array.isArray(this.payTypesAll) ? this.payTypesAll : [];
      // Dollar pay_type ID — nom orqali aniqlash (admin qo'shgan dollarli turlar uchun ham)
      const dollarPt = pts.find(p => {
        const n = String(p.name || '').toLowerCase();
        return n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар');
      });
      const dollarId = dollarPt ? dollarPt.id : 3;
      return arr
        .filter(p => Number(p.summa || 0) > 0)
        .map(p => {
          const pt = pts.find(x => x.id === p.pay_type_id);
          const name = pt ? pt.name : ("To'lov #" + p.pay_type_id);
          const isDollar = parseInt(p.pay_type_id) === parseInt(dollarId);
          return {
            pay_type_id: p.pay_type_id,
            pay_type_name: name,
            summa: Number(p.summa || 0),
            is_dollar: isDollar,
          };
        });
    },

    closeReceipt() {
      this.receipt.show = false;
      // Tahrirlash rejimida — chek yopilgach savdolar ro'yxatiga qaytamiz
      if (this.editId) {
        this.editId = null;
        this.$router.push('/chiqim/index');
        return;
      }
      this._skipAutoSave = true;
      this.cart = [];
      this.form = {
        kontragent_id: null,
        master_user_id: null,
        bron_id: null,
        car_number: '',
        comment: '',
        skidka_summa: 0,
        paid_summa: 0,
        pay_type_id: 1,
        debt_due_date: null,
        debt_comment: '',
      };
      this.$nextTick(() => { this._skipAutoSave = false; });
      this.fetchBrons();
    },

    // Mavjud savdoni tahrirlash uchun yuklash — cart va form'ni to'ldiradi
    async loadSaleForEdit(id) {
      this._skipAutoSave = true; // tahrirlashda yangi bron yaratilmasin
      this.loading = true;
      try {
        const res = await axios.get(`api/v1/service-sale/id/${id}`);
        const s = res.data || {};
        this.editId = id;
        this.saleType = s.price_type === 'optom' ? 'optom' : 'chakana';

        const cart = [];
        // Mahsulotlar
        (s.items || []).forEach(it => {
          const prod = it.product || {};
          cart.push({
            type: 'product',
            id: it.product_id || prod.id,
            name: prod.name || prod.extra_name || '-',
            qty: Number(it.count || 0),
            price: Number(it.price || 0),
            original_price: Number(it.original_price || 0),
            discount_percent: Number(it.discount_percent || 0),
          });
        });
        // Xizmatlar (paket): packages[] yoki bitta repair_package
        let pkgs = [];
        if (Array.isArray(s.packages) && s.packages.length) {
          pkgs = s.packages;
        } else if (s.repair_package) {
          pkgs = [{
            repair_package_id: s.repair_package_id || s.repair_package.id,
            name: s.repair_package.name,
            labor_price_chakana: s.labor_price_chakana,
            redo_price_chakana:  s.redo_price_chakana,
            labor_price_optom:   s.labor_price_optom,
            redo_price_optom:    s.redo_price_optom,
          }];
        }
        pkgs.forEach(pkg => {
          cart.push({
            type: 'service',
            id: pkg.repair_package_id || pkg.id,
            name: pkg.name || '-',
            qty: 1,
            labor_price_chakana: Number(pkg.labor_price_chakana || 0),
            redo_price_chakana:  Number(pkg.redo_price_chakana || 0),
            labor_price_optom:   Number(pkg.labor_price_optom || 0),
            redo_price_optom:    Number(pkg.redo_price_optom || 0),
          });
        });
        this.cart = cart;

        // Form maydonlari
        this.form.kontragent_id  = s.kontragent_id || null;
        this.form.master_user_id = s.master_user_id || null;
        this.form.bron_id        = s.bron_id || null;
        this.form.car_number     = s.car_number || '';
        this.form.comment        = s.comment || '';
        this.form.skidka_summa   = Number(s.skidka_summa || 0);
        this.form.paid_summa     = Number(s.paid_summa || 0);
        this.form.dollar_rate    = Number(s.dollar_rate || 1);
        // To'lov breakdown va qarz maydonlari — saqlaganda savdo va qarz to'liq mos bo'lsin
        this.$set(this.form, 'cash_summa',        Number(s.cash_summa || 0));
        this.$set(this.form, 'plastic_summa',     Number(s.plastic_summa || 0));
        this.$set(this.form, 'shot_summa',        Number(s.shot_summa || 0));
        this.$set(this.form, 'dollar_summa',      Number(s.dollar_summa || 0));
        this.$set(this.form, 'qarz_summa',        Number(s.qarz_summa || 0));
        this.$set(this.form, 'qarz_dollar_summa', Number(s.qarz_dollar_summa || 0));
        // Qarz muddati va izohi — tahrirlashda mavjud qiymat ko'rinsin
        this.$set(this.form, 'debt_due_date', s.debt_due_date ? Number(s.debt_due_date) : null);
        this.$set(this.form, 'debt_comment',  s.debt_comment || '');
        this.$set(this.form, 'payments', Array.isArray(s.payments)
          ? s.payments.map(p => ({
              pay_type_id: p.pay_type_id,
              summa: Number(p.summa || 0),
              dollar_rate: Number(p.dollar_rate || 1),
            }))
          : []);

        this.masterPercent = Number(s.master_percent || (s.master && s.master.bonus) || 0);
        if (this.form.kontragent_id) this.fetchClientDebt(this.form.kontragent_id);
      } catch (e) {
        alert("Savdoni yuklashda xato: " + (e.response?.data?.message || e.message));
        this.$router.push('/chiqim/index');
      } finally {
        this.loading = false;
      }
    },

    cancelEdit() {
      this.editId = null;
      this.$router.push('/chiqim/index');
    },

    async submitSale() {
      if (this.cart.length === 0) {
        return alert("Savatcha bo'sh!");
      }

      if (this.qarzSumma > 0) {
        const prevDebt = Number(this.clientDebt || 0);
        const after = prevDebt + this.qarzSumma;
        const fmt = (v) => Number(v).toLocaleString('uz-UZ');
        const msg =
          "⚠️ DIQQAT! Bu savdoda qarz mavjud!\n\n" +
          `To'landi:             ${fmt(Number(this.form.paid_summa || 0))} so'm\n` +
          `Yangi qarz:           ${fmt(this.qarzSumma)} so'm\n` +
          `Mijozning eski qarzi: ${fmt(prevDebt)} so'm\n` +
          `─────────────────────────────────\n` +
          `JAMI QARZ:            ${fmt(after)} so'm\n\n` +
          "Davom etilsinmi?";
        if (!confirm(msg)) return;
      }

      this.loading = true;
      try {
        const sklad_id = localStorage.getItem('sklad_id');

        const services = this.cart
          .filter(i => i.type === 'service')
          .flatMap(srv =>
            Array(Number(srv.qty)).fill(null).map(() => ({
              repair_package_id: srv.id,
              name: srv.name,
              labor_price_chakana: srv.labor_price_chakana,
              redo_price_chakana: srv.redo_price_chakana,
              labor_price_optom: srv.labor_price_optom,
              redo_price_optom: srv.redo_price_optom,
            }))
          );

        const items = this.cart
          .filter(i => i.type === 'product' && !i.from_service)
          .map(i => ({
            product_id: i.id,
            count: i.qty,
            price: i.price,
            summa: i.price * i.qty,
            original_price: Number(i.original_price || 0),
            discount_percent: Number(i.discount_percent || 0),
          }));

        const paidS    = Number(this.form.paid_summa || 0);
        const hasDebt  = Math.max(0, Number(this.totalSum) - paidS) > 0;

        const payload = {
          kontragent_id:  this.form.kontragent_id,
          master_user_id: this.form.master_user_id,
          bron_id:        this.form.bron_id,
          car_number:     this.form.car_number,
          comment:        this.form.comment,
          skidka_summa:   Number(this.form.skidka_summa  || 0),
          paid_summa:     paidS,
          // Multi-payment breakdown — har pay_type uchun alohida summa
          cash_summa:     Number(this.form.cash_summa    || 0),
          plastic_summa:  Number(this.form.plastic_summa || 0),
          shot_summa:     Number(this.form.shot_summa    || 0),
          dollar_summa:   Number(this.form.dollar_summa  || 0),  // USD (to'lov)
          // Qarz dual: qancha qismi $ da, qolgani so'mda
          qarz_dollar_summa: Number(this.form.qarz_dollar_summa || 0), // USD (qarz)
          qarz_summa:        Number(this.form.qarz_summa        || 0), // so'm (qoldiq)
          dollar_rate:    Number(this.form.dollar_rate   || 1),
          sklad_id:       Number(sklad_id),
          price_type:     this.saleType,
          master_percent: this.masterPercent,
          master_summa:   this.masterSumma,
          product_summa:     this.productSumma,
          original_summa:    this.originalSumma,
          arzon_summa:       this.arzonSumma,
          discount_summa:    this.discountSumma,

          summa:             this.totalSum,
          pay_type_id:    Number(this.form.pay_type_id || 1),
          // Dinamik to'lov turlari massivi (backend service_sale_payment'ga saqlaydi)
          payments:       Array.isArray(this.form.payments) ? this.form.payments : [],
          debt_due_date:  hasDebt && this.form.debt_due_date ? Number(this.form.debt_due_date) : null,
          debt_comment:   hasDebt ? (this.form.debt_comment || null) : null,
          services,
          items,
        };

        let res;
        if (this.editId) {
          // Tahrirlash — PATCH: backend eski registerlarni o'chirib qaytadan yozadi
          res = await axios.patch(`api/v1/service-sale/id/${this.editId}`, payload);
        } else {
          res = await axios.post('api/v1/service-sale', payload);
        }
        this.showReceipt(res && res.data);
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Serverda xato"));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.pos-container {
  background-color: #f4f7f9;
  min-height: 100vh;
}
.edit-banner {
  background: linear-gradient(135deg, #f59e0b, #f97316);
  color: #fff;
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 0.9rem;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}
.basket-item {
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.basket-item:hover {
  background: #fff7ed;
  border-color: #fed7aa;
}
.basket-active {
  background: #eff6ff !important;
  border-color: #93c5fd !important;
}
.cursor-pointer { cursor: pointer; }
</style>
